<template>
  <div class="dynamic-sensing">
    <div class="dynamic-sensing__panel">
        <div class="dynamic-sensing__panel__header">
            {{ $t('detail.sa_title') }}
        </div>
        <div class="dynamic-sensing__panel__sa">
            <div class="sa-wrapper">
                <div class="sa-selector">
                    <div class="left">
                        <div class="settings-row__name__title" for="" v-tooltip.top="$t('detail.sa_hover')">
                            {{ $t('detail.sa_select_profile') }}
                        </div>
                    </div>
                    <div class="right">
                        <select v-model="saProfileSelected">
                            <option v-for="(saProfile) in device.version.saProfiles"
                                    :value="saProfile.id"
                                    :key="saProfile.name"
                                    :selected="0">
                                {{ saProfile.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="below">
                    <button v-if="isEnabledButton" class="btn-set-dynamic" @click="updateTentacle()">
                        {{ $t('detail.sa_enable_profile') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import store from '@/store';

export default {
  name: 'DetailSettingsRow',
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
      return {
          saProfileSelected: this.device.saSelected.id,
      };
  },
  computed: {
      isEnabledButton() {
          return this.device.saSelected.id !== this.saProfileSelected;
      },
  },
  methods: {
    updateTentacle() {
      const data = [{
        id: this.device.id,
        selfAwarenessProfile: this.saProfileSelected,
      }];

      this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
        if (response.status === 200) {
            this.flash('Tentacles updated', 'success');
            this.$store.dispatch('tentacle/setUnitByID', this.device.id).then((response) => {
                if (response.status === 200) {
                }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-sensing {
  margin-top: 4rem;
  padding-left: 8rem;
    @media only screen and (max-width: 990px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 991px) and (max-width: 1199px) {
        padding-left: 0;
        width: 90%;
        margin-right: auto;
        margin-left: 5%;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
        margin-left: -4%;
        width: 100%;
    }

  &__panel {
    border-radius: 2rem;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    position: relative;

    .loading-wrapper {
      position: absolute;
      top: 5rem;
      width: 100%;
      height: calc(100% - 10rem);
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
    }

    &__header {
      padding: 0 3rem;
      height: 6rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;

      button {
        width: 150px;
        color: #f7f7f7;
        margin-left: auto;
        margin-top: 0.5rem;
        background-color: $company-color;
        border: none;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 2.8rem;
        cursor: pointer;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
      }
    }

    &__sa {
      padding: 0 3rem;
      height: 10rem;
      border-bottom: 0.1rem solid $border-color;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 1.4rem;
      color: $grey;

      button {
        width: 150px;
        color: #f7f7f7;
        margin-left: auto;
        margin-top: 0.5rem;
        background-color: $company-color;
        border: none;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        height: 2.8rem;
        cursor: pointer;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
      }

      .sa-wrapper {
        display: flex;
        width: 100%;
        align-content: space-around;
        flex-direction: column;
        justify-content: flex-start;
        height: 70px;
      }

      .sa-selector {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }

    &__content {
      padding: 0 3rem;
      font-size: 1.3rem;
      @media only screen and (max-width: 1400px) {
        min-height: 26rem;
      }
    }
  }

    .detail-settings {
        .settings-row {
            display: flex;
            justify-content: space-between;
            padding: 0;

            .lqi-info {
              margin-left: auto;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              padding: 10px 15px;
              line-height: 20px;
              font-size: 15px;
              font-weight: 500;
            }

            select {
              max-width: 20rem;
            }

            &:last-of-type {
              border-bottom: 0;
            }

            input {
                border: 1px solid $border-color;
                color: $middle-grey;
                background-color: $bg;
                border-radius: 3px;
                line-height: 2rem;
                padding: 0.3rem 1rem;
                min-width: 10rem;
                max-width: 20rem;
            }
        }
    }
}

</style>
